module.exports = __webpack_public_path__ + "static/media/brigitte.ae63532f.jpg";